// UI
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// React
import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

/**
 * Scratch screen: dumps a component's bill of materials as JSON. Kept because
 * it is routed (/assembly/create-new); the real creation form is create.jsx.
 */
export default function ProductionOrderCreateNew() {
    // Router
    const [searchParams] = useSearchParams()

    // Code
    const component_id = searchParams.get('component_id')

    const [component, setComponent] = useState(null)

    // Load component
    const { requestGet } = useAxiosApi()

    const loadComponent = async () => {
        const { data } = await requestGet(`/components/${component_id}/children`)

        setComponent(data)
    }

    useEffect(() => {
        if (component_id) {
            loadComponent()
        }
    }, [component_id])

    const breadcrumbs = [
        {
            label: 'Assemblages',
            href: '/assembly',
        },
        {
            label: 'Créer un assemblage',
        },
    ]

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />

            <pre>{JSON.stringify(component, null, 2)}</pre>
        </div>
    )
}
